import { JSX } from "react";
import { useTranslation } from "react-i18next";

import Button from "@/components/buttons/Button.tsx";
import { IconPaymentResult } from "@/components/icons";

import useModalRouter from "@/hooks/useModalRouter";

const PaymentFailModal = (): JSX.Element => {
  const { t } = useTranslation();

  const { closeModal } = useModalRouter();

  return (
    <div className={"headless-dialog-content flex flex-col items-center gap-6 text-center"}>
      <IconPaymentResult name={"fail"} className={"h-[11.563rem] w-[12.5rem]"} />
      <div className={"space-y-3 text-center"}>
        <h2 className={"text-[2rem]/10 font-semibold max-lg:text-2xl/7"}>{t("Payment.payment-fail")}</h2>
        <p className={"mt-3 text-lg/5 max-lg:text-base/normal"}>{t("Payment.payment-fail-message")}</p>
      </div>
      <Button
        aria-label={t("Actions.retry")}
        onClick={closeModal}
        className={"w-fit min-w-[19.5rem] max-sm:w-full max-sm:min-w-full"}
      >
        {t("Actions.close")}
      </Button>
    </div>
  );
};

export default PaymentFailModal;
